import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';
import CustomTypography from '../Typography/CustomTypography';
import styles from '../../assets/jss/components/ListCompanyCustomLayout';
import Button from '../Button/CustomButton';
import {
    AddIcon, RemoveIcon,
} from '../Icons/Icon';

const useStyles = makeStyles(styles);

const ListCompanyCustomLayout = ({
    urlImg,
    companyName,
    industryName,
    content,
    isAddFavorite,
    handleAddFavorite,
    handleViewDetail,
    isFreeExhibition,
    customColor,
    isCursor,
}) => {
    const classes = useStyles(customColor);
    const intl = useIntl();

    const onClick = (e) => {
        e.stopPropagation();
        handleAddFavorite();
    };

    return (
        <Paper elevation={3} classes={{ root: classes.room }} style={{ cursor: isCursor ? 'pointer' : 'auto' }}>
            <GridContainer className={classes.container} onClick={() => handleViewDetail()}>
                <GridItem sx={12} className={classes.items}>
                    <img
                        src={urlImg}
                        alt=""
                        className={classes.productItemImg}
                    />
                </GridItem>
                <GridItem sx={12} className={classes.content}>
                    <CustomTypography
                        className={classes.listProfileName}
                        variant="h5"
                        bold
                    >
                        {companyName}
                    </CustomTypography>
                    <CustomTypography
                        className={classes.listProfileIndustry}
                        bold
                        customColor={customColor?.contents_text_color}
                    >
                        {industryName}
                    </CustomTypography>
                    {!isFreeExhibition && (
                        <GridContainer className={classes.listProfile}>
                            <GridItem xs={12} sm={9} md={7} lg={9} className={classes.listProfileContent}>
                                <CustomTypography
                                    className={classes.listContent}
                                    customColor={customColor?.contents_text_color}
                                >
                                    {content}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={3} md={5} lg={3} className={classes.listAction}>
                                <div>
                                    {isAddFavorite && (
                                        <Button
                                            color="navy"
                                            className={classes.buttonAddFavorite}
                                            onClick={(e) => onClick(e)}
                                            buttonTextColor={isAddFavorite ? (customColor?.contents_text_color || '#000000de') : customColor?.button_text_color}
                                            buttonBackgroundColor={isAddFavorite
                                                ? (customColor?.button_background_color?.delete_favorite_company || '#d8e2f3')
                                                : customColor?.button_background_color?.common_button}
                                        >
                                            {isAddFavorite && (
                                                <RemoveIcon color={customColor?.contents_text_color || '#000000de'} />
                                            )}
                                            {intl.formatMessage({ id: 'organizerPosterList.listCompany' })}
                                        </Button>
                                    )}
                                    {!isAddFavorite && (
                                        <Button
                                            color="navy"
                                            className={classes.buttonAddFavorite}
                                            onClick={(e) => onClick(e)}
                                            buttonTextColor={isAddFavorite ? (customColor?.contents_text_color || '#000000de') : customColor?.button_text_color}
                                            buttonBackgroundColor={isAddFavorite
                                                ? (customColor?.button_background_color?.delete_favorite_company || '#d8e2f3')
                                                : customColor?.button_background_color?.common_button}
                                        >
                                            {!isAddFavorite && (
                                                <AddIcon color={customColor?.button_text_color || '#fff'} />
                                            )}
                                            {intl.formatMessage({ id: 'organizerPosterList.listCompany' })}
                                        </Button>
                                    )}
                                </div>
                            </GridItem>
                        </GridContainer>
                    )}
                    {isFreeExhibition && (
                        <GridContainer className={classes.listProfile}>
                            <GridItem className={classes.listProfileContent}>
                                <CustomTypography
                                    className={classes.listContent}
                                    customColor={customColor?.contents_text_color}
                                >
                                    {content}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    )}
                </GridItem>
            </GridContainer>
        </Paper>
    );
};

ListCompanyCustomLayout.defaultProps = {
    urlImg: '',
    companyName: '',
    industryName: '',
    content: '',
    isAddFavorite: false,
    handleAddFavorite: () => {},
    handleViewDetail: () => {},
    isFreeExhibition: false,
    customColor: {},
    isCursor: false,
};

ListCompanyCustomLayout.propTypes = {
    urlImg: PropTypes.string,
    companyName: PropTypes.string,
    industryName: PropTypes.string,
    content: PropTypes.string,
    isAddFavorite: PropTypes.bool,
    handleAddFavorite: PropTypes.func,
    handleViewDetail: PropTypes.func,
    isFreeExhibition: PropTypes.bool,
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    isCursor: PropTypes.bool,
};

export default ListCompanyCustomLayout;
